import { gql } from "@apollo/client";

const ADD_AI_RATING = gql`
  mutation addAiRating($input: AddAiRatingInput!) {
    addAiRating(input: $input) {
      success
    }
  }
`;

export { ADD_AI_RATING };
